import type { Translate } from 'providers/ApplicationContext';
import type { ReactNode } from 'react';
import type { DrawerBusy } from './useAdminDrawer';

type DrawerButtonProps = {
	children: ReactNode;
	onClick: () => void;
	variant: 'back' | 'cancel' | 'confirm-cancel' | 'update';
};

function DrawerButton({ children, onClick, variant }: Readonly<DrawerButtonProps>) {
	return (
		<button className={`admin-drawer-btn admin-drawer-btn--${variant}`} onClick={onClick} type="button">
			{children}
		</button>
	);
}

type AdminDrawerActionsProps = {
	busy: DrawerBusy;
	confirmCancel: boolean;
	onConfirmCancel: () => void;
	onSubmit: () => void;
	setConfirmCancel: (value: boolean) => void;
	t: Translate;
};

export function AdminDrawerActions({
	busy,
	confirmCancel,
	onConfirmCancel,
	onSubmit,
	setConfirmCancel,
	t
}: Readonly<AdminDrawerActionsProps>) {
	return (
		<div className="admin-drawer-actions">
			{!busy && !confirmCancel && (
				<div className="admin-drawer-actions__row">
					<DrawerButton onClick={onSubmit} variant="update">
						{t('admin_update_process_btn')}
					</DrawerButton>
					<DrawerButton onClick={() => setConfirmCancel(true)} variant="cancel">
						{t('cancel_process')}
					</DrawerButton>
				</div>
			)}

			{!busy && confirmCancel && (
				<div className="admin-drawer-confirm">
					<div className="admin-drawer-confirm__title">{t('cancel_process')}</div>
					<div className="admin-drawer-confirm__body">{t('cancel_process_description')}</div>
					<div className="admin-drawer-confirm__footer">
						<DrawerButton onClick={() => setConfirmCancel(false)} variant="back">
							{t('back')}
						</DrawerButton>
						<DrawerButton onClick={onConfirmCancel} variant="confirm-cancel">
							{t('confirm_cancel_process')}
						</DrawerButton>
					</div>
				</div>
			)}

			{!!busy && (
				<div className="admin-drawer-busy">
					<span className="admin-drawer-spinner" />
					{busy === 'cancel' ? t('cancelling_process') : t('updating_status')}
				</div>
			)}
		</div>
	);
}
